module.exports = __webpack_public_path__ + "static/media/3.d641a23f.jpg";